export type Icons =
  | 'icon-account'
  | 'icon-bag'
  | 'icon-back'
  | 'icon-bucket'
  | 'icon-carro'
  | 'icon-chart'
  | 'icon-close-x'
  | 'icon-dashboard'
  | 'icon-delivery'
  | 'icon-eye'
  | 'icon-eye-closed'
  | 'icon-filter'
  | 'icon-finance'
  | 'icon-invoice'
  | 'icon-pin'
  | 'icon-promo'
  | 'icon-quote'
  | 'icon-search'
  | 'icon-user'
  | 'icon-user-protection';

type IconProps = {
  className?: string;
  color?: string;
  fill?: string;
  height?: number;
  id: Icons;
  stroke?: string;
  width?: number;
};

function Icon(props: IconProps) {
  const { className, fill = 'none', id, ...rest } = props;

  return (
    <svg {...rest} fill={fill}>
      <use xlinkHref={`/assets/img/icon-sprite.svg#${id}`} />
    </svg>
  );
}

export default Icon;
